<div class="header">
  <div class="header-container container-lg d-flex flex-row align-items-center justify-content-between p-0 m-auto">
    <div class="logo logo-dark">
      <a routerLink="/explore">
        <img src="assets/icons/logo.png" alt="Logo" class="logo-full" loading="eager">
        <img class="logo-fold" src="assets/icons/logo-fold.png" alt="Logo" loading="eager">
      </a>
    </div>
    <div class="logo logo-white">
      <a routerLink="/explore">
        <img src="assets/icons/logo-white.png" alt="Logo" class="logo-full">
        <img class="logo-fold" src="assets/icons/logo-fold-white.png" alt="Logo">
      </a>
    </div>
    <div class="nav-wrap">
      <ul class="nav-left">
        <li class="mobile-toggle">
          <button nz-button nzType="link" (click)="toggleExpand()">
            <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" nzTheme="outline"></i>
          </button>
        </li>
        <!--<li *ngIf="(isAuth$ | async)">
          <a (click)="searchToggle()">
            <i nz-icon nzType="search" nzTheme="outline"></i>
          </a>
          <nz-drawer [nzWidth]="380" nzTitle="Search" [nzVisible]="searchVisible" nzPlacement="left"
                     (nzOnClose)="searchToggle()">
            <app-search></app-search>
          </nz-drawer>
        </li>-->
      </ul>
      <ul class="nav-right">
        <!--<li class="m-l-35 d-none d-md-block">
          <a nz-button nzType="link" class="header-button" id="create-research" [routerLink]="['/create-research']">
            Create Research
          </a>
        </li>-->
        <li class="m-l-35 d-none d-md-block" *ngIf="(isAuth$ | async)">
          <a nz-button nzType="link" class="header-button" id="auth-view-research"
             [routerLink]="['/view-all-research']">
            Your Car Research
          </a>
        </li>
        <li class="m-l-35 d-none d-md-block" *ngIf="(isAuth$ | async)">
          <a nz-button nzType="link" class="header-button" id="auth-saved-vehicles" [routerLink]="['/saved-vehicles']">
            Saved Vehicles
          </a>
        </li>
        <!--        Dont show this option for now till vehicle rankings is up and running-->
        <!--<li class="m-l-35 d-none d-md-block" *ngIf="(isAuth$ | async) && false">
          <span class="p-h-10 pointer header-action" nz-dropdown [nzDropdownMenu]="research" [nzTrigger]="'click'"
                [nzPlacement]="'bottomLeft'" id="auth-research">
            <span class="d-none d-md-block">Research</span>
            <nz-avatar [nzIcon]="'experiment'" nzSrc="" class="d-block d-md-none"></nz-avatar>
          </span>
          <nz-dropdown-menu #research="nzDropdownMenu">
            <ul nz-menu class="">
              <li nz-menu-item>
                <a class="research-button" id="vehicle-rankings-link" [routerLink]="['/rankings']">Vehicle Rankings</a>
              </li>
              <li nz-menu-item>
                <a class="research-button" id="blog-link" [routerLink]="['/blogs']">Blog</a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </li>-->
        <!--<li class="m-l-35" *ngIf="(isAuth$ | async) && !(isAnon$ | async)">
          <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="popNotification" [nzPlacement]="'bottomRight'"
             (click)="openNotifications()" class="d-block d-md-none">
            <nz-badge nzDot class="d-block d-md-none">
              <i nz-icon nzType="bell" nzTheme="outline"></i>
            </nz-badge>
          </a>
          <nz-badge nzDot class="p-r-5 d-none d-md-block">
            <span class="pointer header-action" nz-dropdown nzTrigger="click"
                  [nzDropdownMenu]="popNotification" [nzPlacement]="'bottomRight'" (click)="openNotifications()">
              Alerts
            </span>
          </nz-badge>
          <nz-dropdown-menu #popNotification="nzDropdownMenu">
            <div nz-menu class="pop-notification">
              <div class="p-v-10 p-h-15 border-bottom d-flex justify-content-between align-items-center">
                <p class="text-dark font-weight-semibold m-b-0">
                  <i nz-icon nzType="bell" nzTheme="outline"></i>
                  <span class="m-l-10">Alerts</span>
                </p>
                <a nz-button nzType="link" nzSize="small" class="p-v-5" [routerLink]="'alerts'">
                  <span>View All</span>
                </a>
              </div>
              <ng-scrollbar class="overflow-y-auto" style="max-height: 300px">
                <nz-spin [nzSize]="'large'" [nzSpinning]="isResolvingAlert">
                  <nz-list class="ant-list-item-links" [nzDataSource]="alerts$ | async" [nzRenderItem]="item"
                           [nzItemLayout]="'horizontal'">
                    <ng-template #item let-item>
                      <nz-list-item class="alert-list-item">
                        <a (click)="resolveAlert(item)">
                          <div class="d-flex">
                            <nz-avatar [nzIcon]="iconMap[item.feature]" [ngClass]="colorMap[item.type]"></nz-avatar>
                            <div class="m-l-15">
                              <p class="m-b-0 text-dark">{{item.message}}</p>
                              <p class="m-b-0"><small>{{item.updatedAt | momentCalendar}}</small></p>
                            </div>
                          </div>
                        </a>
                      </nz-list-item>
                    </ng-template>
                  </nz-list>
                </nz-spin>
              </ng-scrollbar>
            </div>
          </nz-dropdown-menu>
        </li>-->
        <li class="m-l-35 d-none d-md-block" *ngIf="(isAuth$ | async) && !(isAnon$ | async)">
          <a nz-button nzType="link" class="header-button" id="blog-link" [routerLink]="['/blogs']">Blog</a>
        </li>
        <li class="m-l-35" *ngIf="(isAuth$ | async) && !(isAnon$ | async)">
          <span class="p-h-10 pointer header-action" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
                [nzPlacement]="'bottomLeft'" id="auth-my-account">
            <span class="d-none d-md-block">My Account</span>
            <nz-avatar [nzIcon]="'user'" [nzSrc]="user?.photoUrl" class="d-block d-md-none"></nz-avatar>
          </span>
          <nz-dropdown-menu #profile="nzDropdownMenu">
            <ul nz-menu class="p-b-15 p-t-20">
              <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                <div class="d-flex m-r-50">
                  <nz-avatar nzSize="large" nzIcon="user" [nzSrc]="user?.photoUrl"></nz-avatar>
                  <div class="m-l-10">
                    <p class="m-b-0 text-dark font-weight-semibold"
                       *ngIf="user && user.name">{{user.name | shorten: 17}}</p>
                    <p class="m-b-0 opacity-07" *ngIf="user && user.email">{{user.email}}</p>
                  </div>
                </div>
              </li>
              <li nz-menu-item *ngFor="let item of PROFILE_DROPDOWN">
                <button nz-button nzType="link" class="p-v-5 d-flex align-items-center justify-content-between"
                        id="{{item.id}}" (click)="profileActions(item.action)">
                  <div>
                    <i class="opacity-04 font-size-16" nz-icon nzType="{{item.icon}}" nzTheme="outline"></i>
                    <span class="m-l-10">{{item.title}}</span>
                  </div>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </li>
        <!--<li class="m-l-35 d-none d-md-block" *ngIf="!(isAuth$ | async)">
          <button nz-button nzType="link" class="header-button" id="unauth-sample-research"
                  [routerLink]="['/sample-research']">Sample Research
          </button>
        </li>-->
        <li class="m-l-35 d-none d-md-block" *ngIf="!(isAuth$ | async) || (isAnon$ | async)">
          <button nz-button nzType="link" class="header-button" id="blog-link-unauth" [routerLink]="['/blogs']">Blog
          </button>
        </li>
        <li class="m-l-35 p-r-0" *ngIf="!(isAuth$ | async) || (isAnon$ | async)">
          <button nz-button nzType="link" class="header-button" id="unauth-login" (click)="navigateToLogin()">Login
          </button>
        </li>
        <li class="m-l-35 p-h-0" *ngIf="!(isAuth$ | async) || (isAnon$ | async)">
          <button nz-button nzType="link" class="header-button" id="unauth-register" (click)="navigateToRegister()">
            Register
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
